import Scrollable from "@components/ui/Scrollable";
import {ComponentElem, ScrollableSetting} from "@components/interfaces";

export default class PromoteList extends Scrollable{
  constructor(elem: ComponentElem){

    super(elem, {
      itemWidth: 330,
      itemHeight: 300,
      gapX: 15,
      gapY: 15,
      numCols: 3,
      buttonMode: "press"
    },
    {
      itemWidth: 590,
      itemHeight: 536,
      gapX: 15,
      gapY: 15,
      numCols: 1,
      buttonMode: "click"
    });
    
  }
}